/* eslint-disable no-useless-escape */
import { Select } from '@root-gipro/modules/userProjects/components/Project/CheckPlate/Select'
import React, { FC, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
	deleteUnnormalizedСostsArchive,
	getTplUnnormalizedСostsArchive,
	getUnnormalizedСostsArchive,
	setT7EditModeArchive,
	uploaderUnnormalizedСostsArchive,
} from '@root-gipro/modules/userArchive/store/actions'
import { SelectAction } from '@root-gipro/modules/userProjects/components/Project/DropDown'
import { UnNormalizedCosts } from '@root-gipro/modules/userProjects/components/Project/UnNormalizedCosts'
import { UnNormalizedForm20Costs } from '@root-gipro/modules/userProjects/components/Project/UnNormalizedForm20Costs'
import {
	AddNewVersion,
	autoAddUnc,
	changeVersionName,
	chooseProject,
	deleteUnnormalizedСosts,
	getCheckedErrors,
	getDeflators,
	getInvestGroup,
	getT7Data,
	getTplUnnormalizedСosts,
	getUnnormalizedСosts,
	saveUserProject,
	setOnlyPIR,
	setProjectActual,
	setProjectAdditional,
	setProjectCode,
	setProjectDecreeName,
	setProjectDecreeNumber,
	setProjectFilial,
	setProjectFinancialNeeds,
	setProjectGroupNum,
	setProjectName,
	setProjectPhase,
	setProjectRationale,
	setProjectRegions,
	setProjectValuation,
	setProjectYears,
	setT7EditMode,
	setTechConnect,
	setUncAutoAdd,
	setYears,
	updateDeflators,
	uploaderUnnormalizedСosts,
} from '@root-gipro/modules/userProjects/store/actions'

import {
	Box,
	Button,
	Chip,
	Grid,
	IconButton,
	List,
	ListItem,
	ListItemText,
	Popover,
	TextareaAutosize,
	TextField,
	Typography,
} from '@material-ui/core'

import AddIcon from '@material-ui/icons/Add'
import InsertInvitationIcon from '@material-ui/icons/InsertInvitation'
import ListIcon from '@material-ui/icons/List'
import { DatePicker } from '@material-ui/pickers'
import { ModalContext } from '@root-gipro/context/modal-context'
import { showNotify } from '@root-gipro/modules/notify/store/actions'
import { CalendarOnce } from '@root-gipro/modules/userProjects/components/Project/CheckPlate/CalendarOnce'
import { CheckProjectWindow } from '@root-gipro/modules/userProjects/components/Project/Modal'
import '@root-gipro/modules/userProjects/styles/CheckPlate.scss'
import { formatValue } from '@root-gipro/modules/userProjects/utils/formatValue'
import { projectPhases, requiredFields } from '@root-gipro/modules/userProjects/utils/helpers'
import { PrimaryBtn, SecondaryBtn } from '@root-gipro/shared/Button/Button'
import CheckboxItem from '@root-gipro/shared/CheckboxShared/Checkbox'
import FailurePage from '@root-gipro/shared/FailurePage/FailurePage'
import { Input } from '@root-gipro/shared/FormElements'
import PrikazLinks from '@root-gipro/shared/PrikazLinks/PrikazLinks'
import store from '@root-gipro/store'
import { IFilial, IRegion } from '@root-gipro/store/interfaces'
import { IState } from '@root-gipro/store/interfaces/state'
import { formatedDeflatorValue, intFormat, prettyCost } from '@root-gipro/utils/helpers/common'
import { cloneDeep, isEqual } from 'lodash'
import PopupState, { bindPopover, bindTrigger } from 'material-ui-popup-state'
import { Link, useHistory, useParams, useRouteMatch } from 'react-router-dom'
import InputBox from './InputBox'
import LabelInput from './LabelInput'
import CustomAutocomplete from './SelectInput'
import StageSelect from './StageSelect'
import { Chat } from '@material-ui/icons'
import CommentModal from './components/CommentModal'

interface IVersion {
	userProjectId: number
	name: string
	is_actual: boolean
	unc_sort: string
}

const CheckPlate: FC = () => {
	const dispatch = useDispatch()
	const routeMatch = useRouteMatch()
	const history = useHistory()
	const { id: userProjectId }: { id: any } = useParams()

	const typePageUrl: string = routeMatch.path.split('/')[1]
	const currentState = typePageUrl === 'user-archive' ? 'userArchives' : 'userProjects'
	const { regions, filial, failure, company } = useSelector((state: IState) => state.public)
	const { resultFilterState } = useSelector((state: IState) => state.filter.userProjects)

	const { originalObj, projectObj, sectionIds, t7EditMode, deflators: deflatorsState } = useSelector(
		(state: IState) => state[currentState]
	)
	const currentYear = new Date().getFullYear()

	const [projectYears, setProjectYearsState] = useState<[number, number]>([
		projectObj.yearBegin || currentYear,
		projectObj.yearEndOffer || currentYear,
	])

	useEffect(() => {
		setProjectYearsState([projectObj.yearBegin || currentYear, projectObj.yearEndOffer || currentYear])
	}, [projectObj.yearBegin, projectObj.yearEndOffer])

	useEffect(() => {
		if (!projectObj.id) {
			dispatch(setProjectYears(currentYear, currentYear))
		}
	}, [])

	useEffect(() => {
		let versionsProject: IVersion[] | [] = []
		if (projectObj.versions) {
			versionsProject = [...projectObj.versions]
		}
		// setVersions(versionsProject)
	}, [originalObj])

	const { selectedSectionIds, uncs, investGroups, copyAlert, savedProjectTrigger } = useSelector(
		(state: IState) => state.userProjects
	)

	const sectionIdsArr: number[] = sectionIds.map(item => Number(item.id))
	const { accessory, setAccessory, accessoryRef, setAnchorEl, anchorEl } = useContext(ModalContext)
	const [defaultRegions, setDefaultRegions] = useState<IRegion[]>([])
	const [defaultFilial, setDefaultFilial] = useState<IFilial>()
	const [initFilial, setInitFilial] = useState<IFilial[]>([])
	const [isArchived, setIsArchived] = useState<boolean>(false)
	const [isLocked, setIsLocked] = useState<boolean>(false)
	const [isAuthorProject, setIsAuthorProject] = useState<boolean>(false)
	const [newAddedVersionName, setNewAddedVersionName] = useState('')
	const { isAdmin, id } = store.getState().auth.user
	const [isNewVersion, setIsNewVersion] = useState<boolean>(false)

	const [versions, setVersions] = useState<IVersion[] | []>([])

	const [selectedDate, setSelectedDate] = React.useState<Date | null>(new Date())
	const [isOpenAddVersionDate, setIsOpenAddVersionDate] = React.useState<boolean>(false)

	const [isUpdated, setIsUpdated] = useState(false)
	const [changedFields, setChangedFields] = useState<string[]>([])
	const prevProjectRef = useRef<any>(null)
	const initializedRef = useRef(false) // контроль первого присвоения
	const emptyProjectRef = useRef<any>(null)
	const initializedEmptyRef = useRef(false) // контроль первого присвоения для нового проекта
	const isFirstRender = useRef(true)

	const url: string = location.pathname.slice(1)

	const { filter } = useSelector((state: IState) => state)

	const currentFilter =
		url === 'common-projects'
			? filter.commonProjects
			: url === 'user-projects'
			? filter.userProjects
			: url === 'user-archive'
			? filter.userArchive
			: filter.userProjects

	const { showFilterState } = useSelector((state: IState) => currentFilter)

	const handleYearsChange = (newYear: number, type: 'start' | 'end') => {
		if (type === 'start') {
			const updatedStart = newYear
			const updatedEnd = Math.max(newYear, projectYears[1])
			setProjectYearsState([updatedStart, updatedEnd])
			dispatch(setProjectYears(updatedStart, updatedEnd))

		} else {
			const updatedEnd = newYear
			const updatedStart = Math.min(projectYears[0], newYear)
			setProjectYearsState([updatedStart, updatedEnd])
			dispatch(setProjectYears(updatedStart, updatedEnd))
		}
	}

	const handleAnotherSave = () => {
		const { author, ...projectObjData } = projectObj
		const uncSort = [...versions]
		if (typePageUrl === 'user-archive') return
		if (projectObj.id && projectObj?.unc_sort && uncSort) {
			const clone = Object.assign({}, projectObjData)
			delete clone.id
			delete clone.userId
			dispatch(saveUserProject(clone, false, projectObjData.id, true, true))
		}
	}

	//при изменении проекта
	useEffect(() => {
		if (projectObj?.id) {
			if (!initializedRef.current) {
				if (!!projectObj.id == true) {
					prevProjectRef.current = cloneDeep(projectObj) // копия оригинала
					initializedRef.current = true
					return
				}
			}
			if (projectObj.id !== prevProjectRef.current.id) {
				prevProjectRef.current = cloneDeep(projectObj) // копия оригинала
				initializedRef.current = true
				return
			}
		}
	}, [projectObj, initializedRef?.current, savedProjectTrigger, isFirstRender?.current])

	const checkSaves = () => {
		if (projectObj?.id) {
			if (!initializedRef.current) {
				return
			}

			const prevProject = prevProjectRef.current
			const newChangedFields: string[] = []

			Object.keys(projectObj).forEach(key => {
				//@ts-ignore
				const prevValue = prevProject[key]
				//@ts-ignore
				const currValue = projectObj[key]

				if (key !== 'totalInvestmentUncOffer' && key !== 'is_template') {
					if (key == 'archive') {
						if (!!prevValue !== !!currValue) {
							newChangedFields.push(key)
						}
					}
					if (key == 'sumUncCostWithNds') {
						return
					} else if (key == 'offerRationale' || key == 'decreeName' || key == 'decreeNumber' || key == 'phase') {
						if (currValue == '') {
							if (!!prevValue == !!currValue) {
								return
							} else if (prevValue !== currValue) {
								newChangedFields.push(key)
							}
						} else if (currValue !== '' && prevValue !== currValue) {
							newChangedFields.push(key)
						}
					} else if (!isEqual(prevValue, currValue)) {
						if (key == 'onlyPIR' || key == 'unc_auto_add' || key == 'techConnect') {
							return
						} else {
							newChangedFields.push(key)
						}
					}
				} else if (!isEqual(prevProject.years, projectObj.years)) {
					newChangedFields.push('years')
				}
				// }
			})

			if (newChangedFields.length > 0) {
				setIsUpdated(true)
				setChangedFields(newChangedFields)
			} else {
				setIsUpdated(false)
				setChangedFields(newChangedFields)
			}
		}
	}

	const checkCheckBoxSaves = () => {
		if (!projectObj?.id || !initializedRef.current) return

		const prevProject = prevProjectRef.current
		const newChangedFields: string[] = []

		const newPrevProject = { ...prevProject }

		let updated = false

		Object.keys(projectObj).forEach(key => {
			if (key === 'onlyPIR' || key === 'unc_auto_add' || key === 'techConnect') {
				//@ts-ignore
				if (!!prevProject[key] !== !!projectObj[key]) {
					//@ts-ignore
					newPrevProject[key] = projectObj[key]
					updated = true
					handleAnotherSave()
				}
			}
		})

		if (updated) {
			prevProjectRef.current = newPrevProject
		}

		setIsUpdated(newChangedFields.length > 0)
		setChangedFields(newChangedFields)
	}

	useEffect(() => {
		checkSaves()
	}, [JSON.stringify(projectObj)])

	useEffect(() => {
		checkCheckBoxSaves()
	}, [projectObj.unc_auto_add, projectObj.techConnect, projectObj.onlyPIR])

	const saveButtonTitle = () => {
		if (changedFields.length && projectObj?.id) {
			if (changedFields.includes('actualFunding') || changedFields.includes('years')) {
				return 'Рассчитать и сохранить'
			} else {
				return 'Cохранить'
			}
		} else {
			return 'Cохранить'
		}
	}

	const cancelProjectUpdates = () => {
		dispatch(chooseProject(prevProjectRef?.current))
	}

	const companyId = Number(localStorage.getItem('companyId'))

	const handleDateChange = (date: Date | null) => {
		const dateStr = `${date!.getDate()}.${date!.getMonth() + 1}.${date?.getFullYear()} | `

		const splitValue = newAddedVersionName.split('|')
		if (splitValue.length <= 1) {
			setNewAddedVersionName(`${dateStr}${newAddedVersionName}`)
		} else {
			const strWithoutDate = splitValue.slice(1)
			setNewAddedVersionName(`${dateStr}${strWithoutDate}`)
		}
		setSelectedDate(date)
	}

	const precision = deflatorsState?.precision ? deflatorsState?.precision : 12

	useEffect(() => {
		!investGroups.length && dispatch(getInvestGroup())
	}, [investGroups])

	useEffect(() => {
		const isArchived = typePageUrl.includes('user-archive')

		setIsArchived(isArchived)
	}, [])

	useEffect(() => {
		setIsAuthorProject(projectObj.userId === id)
		setIsLocked(originalObj.locked)
	}, [projectObj, originalObj])

	useEffect(() => {
		let versionsProject: IVersion[] | [] = []
		if (projectObj.versions) {
			versionsProject = [...projectObj.versions]
		}
		setVersions(versionsProject)
	}, [originalObj])

	const years = useMemo(() => {
		let years: any[] = []

		if (projectObj && projectObj.years) {
			years = Object.keys(projectObj.years)

			return years
				.filter(year => Number(year) >= 2018)
				.map(year => {
					return [year, projectObj.years[year]?.offer ?? 0]
				})
		}
	}, [projectObj])

	const filledYears = useMemo(() => {
		const fillMissingYears = (years: any[] | undefined, uncSort: number): any[] => {
			if (!years) return []

			const begin = projectObj.yearBegin ? projectObj.yearBegin : 2023
			const updatedYears: any[] = []
			if (uncSort === 2024) {
				for (let i = 2018; i < begin; i++) {
					updatedYears.push([i, years[i]?.offer ?? 0])
				}

				years.forEach(([year, value]) => {
					if (year >= begin) {
						updatedYears.push([year, value])
					}
				})

				return updatedYears.sort(([a], [b]) => a - b)
			}

			if (uncSort === 2018) {
				// Заполняем недостающие годы с 2018 года нулями
				const minStart = uncSort
				const existingYears = years ? years.map(([year]) => year) : []
				const minYear = Math.min(minStart, existingYears.length > 0 ? Math.min(...existingYears) : minStart)

				const filledYears: [number, number][] = [...years]

				for (let i = minYear; i < (existingYears.length > 0 ? Math.min(...existingYears) : minStart); i++) {
					if (!existingYears.includes(i)) {
						filledYears.push([i, 0])
					}
				}
				return filledYears.sort(([a], [b]) => a - b)
			}

			return years
		}

		//@ts-ignore
		return fillMissingYears(years, Number(projectObj.unc_sort))
	}, [years, projectObj.unc_sort, projectObj.actualFunding])

	// Сортируем массив по годам (на случай, если порядок нарушен)
	filledYears.sort((a, b) => a[0] - b[0])

	const deflators = useMemo(() => {
		if (!projectObj?.years || !Array.isArray(projectObj?.deflators)) return []

		const deflatorsMap = projectObj?.deflators?.reduce<Record<string, number>>((acc, item) => {
			const year = Object.keys(item)[0]
			acc[year] = item[year]
			return acc
		}, {})

		const years = Object.keys(projectObj.years)

		const dataArr = years.map(year => {
			const deflatorRaw = deflatorsMap[year] ?? 0
			const offer = projectObj.years[year]?.offer ?? 0

			const formattedDeflator = String(Number(formatValue(deflatorRaw, precision + 1)).toFixed(precision))

			return {
				year: Number(year),
				deflator: formattedDeflator,
				offer,
			}
		})

		return dataArr
	}, [projectObj, precision])

	const userFilialId = localStorage.getItem('filialId')

	const userCompanyId = localStorage.getItem('companyId')

	const userDefaultRegionIdsInFilial = filial?.find(f => Number(f.id) === Number(userFilialId))?.regionId

	const userDefaultRegionIdsInCompany = company?.find(f => Number(f.id) === Number(userCompanyId))?.regionIds

	const companyFilter = company?.filter(company => resultFilterState?.companyId == company.name)[0]

	const filialCompany: any = filial?.filter(f => f.id === projectObj?.filialId)

	const userRegionIds = userDefaultRegionIdsInFilial ? [userDefaultRegionIdsInFilial] : userDefaultRegionIdsInCompany

	const defaultRegionName = 'Москва'

	const defaultRegionId = useMemo(() => {
		if (userRegionIds?.length) {
			return userRegionIds
		} else {
			return regions.find(region => region.searchName === defaultRegionName)?.id
		}
	}, [regions])

	const getCurrentRegions = useMemo(() => {
		try {
			return regions.filter(
				(region: IRegion) => projectObj.regionIds.length && projectObj.regionIds.indexOf(region.id) !== -1
			)
		} catch (error) {
			console.log(error)
		}
	}, [projectObj.regionIds.length, defaultRegionId?.length])

	const getCurrentFilial = useMemo(() => {
		try {
			return filial.find((filial: IFilial) => {
				return filial.id === projectObj?.filialId
			})
		} catch (error) {
			console.log(error)
		}
	}, [projectObj.filialId, filial])

	const defaultFilialId: any = useMemo(() => {
		if (Array.isArray(resultFilterState.filialId)) {
			return filial?.find(
				filial => Array.isArray(resultFilterState.filialId) && resultFilterState.filialId.includes(filial.name)
			)?.id
		} else if (!resultFilterState.filialId) {
			return filial.find((filial: IFilial) => {
				return filial.companyId == companyFilter?.id
			})?.id
		} else {
			return filial?.find(el => el.id === 999)?.id
		}
	}, [initFilial, resultFilterState.filialId])

	const resetChangedFields = () => {
		setChangedFields(() => [])
		setIsUpdated(() => false)
		setChangedFields(() => [])
		prevProjectRef.current = null
		initializedRef.current = false // контроль первого присвоения
		emptyProjectRef.current = null
		initializedEmptyRef.current = false
	}
	const handlerClickSave = () => {
		const { author, ...projectObjData } = projectObj
		const emptyFields: string[] = []

		requiredFields.forEach(({ field, message }) => {
			if (field == 'regionIds') {
				if (!defaultRegions.length) {
					emptyFields.push(message)
				}
			} else {
				if (!projectObjData[field]) {
					emptyFields.push(message)
				}
			}
		})

		if (emptyFields.length > 0) {
			dispatch(
				showNotify({
					type: 'warning',
					message: `Не заполнены следующие обязательные поля: ${emptyFields.join(', ')}`,
				})
			)
			return
		}
		const allUncHasVoltage = uncs && uncs.every(item => item.voltage)

		if (!allUncHasVoltage) {
			dispatch(
				showNotify({
					type: 'warning',
					message: 'Нельзя выполнить расчет, т.к. проект содержит расценки без напряжения',
				})
			)
			return
		}

		const uncSort = [...versions]
			.filter((version: IVersion) => version?.unc_sort === projectObj.unc_sort)
			.filter((version: IVersion) => version?.userProjectId === Number(projectObj.id))[0]
		if (!projectObj.id && projectObj?.unc_sort) {
			dispatch(
				AddNewVersion(
					projectObj,
					`УНЦ ${projectObj.unc_sort}`,
					typePageUrl,
					projectObj?.unc_sort,
					showFilterState?.ipr_id
				)
			)
		} else if (projectObj.id && projectObj?.unc_sort && !uncSort) {
			projectObj?.unc_sort &&
				dispatch(AddNewVersion(projectObj, `УНЦ ${projectObj.unc_sort}`, typePageUrl, projectObj?.unc_sort))
		} else if (projectObj.id && projectObj?.unc_sort && uncSort) {
			const clone = Object.assign({}, projectObjData)
			delete clone.id
			delete clone.userId
			dispatch(saveUserProject(clone, false, projectObjData.id, true, true))
			return
		}
		if (typePageUrl === 'user-archive') return

		if (projectObj?.unc_sort) {
			if (uncSort) {
				history.push(`/${typePageUrl}/project/${uncSort.userProjectId}/parameters`)
			}
		}
		resetChangedFields()
	}

	useEffect(() => {
		if (isFirstRender.current) {
			isFirstRender.current = false
			return
		}
		resetChangedFields()
	}, [savedProjectTrigger])
	const handlerChangeCheckbox = (name: string, checked: boolean) => {
		try {
			if (name === 'techConnect') {
				dispatch(setTechConnect(checked))
			} else if (name === 'onlyPIR') {
				dispatch(setOnlyPIR(checked))
			} else if (name === 'unc_auto_add') {
				dispatch(setUncAutoAdd(checked))
			}
		} catch (e) {
			console.log(e)
		}
	}

	const openWindow = useCallback(
		(e: React.MouseEvent<HTMLElement>) => {
			if (e.currentTarget.dataset.popup === 'select-f20' || e.currentTarget.dataset.popup === 'check-project') {
				setAnchorEl!(e.currentTarget)
				setAccessory!('check-list')
				if (accessoryRef) accessoryRef.current = accessory
			} else {
				const isDelete = e.currentTarget.dataset.popup === 'del-project'
				if (isDelete && originalObj.locked && isAdmin) {
					dispatch(
						showNotify({
							type: 'warning',
							message: `Нельзя удалить расчет, так как он заблокирован. Для удаление сначала разблокируйте расчет`,
						})
					)
				} else if (isDelete && originalObj.locked && !isAdmin) {
					dispatch(
						showNotify({
							type: 'warning',
							message: `Нельзя удалить расчет, так как он заблокирован. Для удаление расчета обратитесь к администратору`,
						})
					)
				} else if (isDelete && !originalObj.locked && !isAdmin && !isAuthorProject) {
					dispatch(
						showNotify({
							type: 'warning',
							message: `У вас есть доступ на удаление только своих расчетов. Для удаление расчета обратитесь к его автору или администратору`,
						})
					)
				} else if (
					(isDelete && !originalObj.locked && !isAdmin && isAuthorProject) ||
					(isDelete && !originalObj.locked && isAdmin)
				) {
					setAnchorEl!(e.currentTarget)
					setAccessory!('check-list')
					if (accessoryRef) accessoryRef.current = accessory
				}
			}
		},
		[setAnchorEl, isAdmin, isAuthorProject, originalObj]
	)

	useEffect(() => {
		if (companyFilter?.id && !projectObj.id) {
			setInitFilial(filial?.filter(f => f.companyId === companyFilter?.id))
		} else if (!companyFilter?.id && !projectObj.id) {
			setInitFilial(filial?.filter(f => f.companyId === companyId))
		} else {
			if (filial.length && projectObj.filialId && filialCompany.length) {
				setInitFilial(filial?.filter(f => f.companyId === filialCompany[0]?.companyId))
			}
		}
	}, [filial, projectObj.filialId, filialCompany.length])

	useEffect(() => {
		if (!projectObj.id && defaultRegionId) dispatch(setProjectRegions(defaultRegionId))
	}, [defaultRegionId, projectObj.id, setProjectRegions])

	useEffect(() => {
		if (getCurrentRegions && defaultRegionId) {
			setDefaultRegions(getCurrentRegions)
		}
	}, [projectObj.regionIds, regions, defaultRegionId?.length, getCurrentRegions?.length])

	useEffect(() => {
		if (!projectObj.id) dispatch(setProjectFilial(defaultFilialId))
	}, [defaultFilialId, projectObj.id])

	useEffect(() => {
		if (getCurrentFilial) setDefaultFilial(getCurrentFilial)
	}, [getCurrentFilial?.id])

	const projectSaved = projectObj.id

	const totalInvestmentUncOffer = projectObj.totalInvestmentUncOffer == null ? 0 : projectObj.totalInvestmentUncOffer
	const valuationOfferForecast = projectObj.valuationOfferForecast == null ? 0 : projectObj.valuationOfferForecast
	const uncExceeding =
		totalInvestmentUncOffer > valuationOfferForecast
			? prettyCost((totalInvestmentUncOffer - valuationOfferForecast) / 10 ** 6)
			: '0.00'

	const red = totalInvestmentUncOffer < 0 ? { color: 'red' } : {}

	useEffect(() => {
		if (projectObj.unc_sort === '2024') {
			setIsNewVersion(true)
		} else {
			setIsNewVersion(false)
		}
	}, [projectObj.unc_sort])

	const handleInputChange = (value: any) => {
		dispatch(setProjectGroupNum(value))
	}

	const [resultMap, setResultMap] = useState<{ [year: string]: string }>({})

	useEffect(() => {
		if (deflators.length) {
			const initialMap = Object.fromEntries(
				deflators.map(row => [row.year, formatedDeflatorValue((row.offer ?? 0) / 1_000_000, precision)])
			)
			setResultMap(initialMap)
		}
	}, [deflators, precision])

	return (
		<div className='container'>
			<div className={`check-plate ${failure ? 'hidden' : ''}`}>
				<Grid container spacing={3} alignItems='center'>
					<Grid item xs={6}>
						<Grid container spacing={1}>
							<Grid item xs>
								<div style={{ display: 'flex', flexDirection: 'column' }}>
									<label htmlFor='project-code' style={{ marginBottom: 4, color: '#555', fontSize: 14 }}>
										Идентификатор
									</label>
									<TextField
										id='project-code'
										variant='outlined'
										size='medium'
										fullWidth
										placeholder='Идентификатор'
										value={projectObj.code || ''}
										disabled={isArchived || isLocked}
										onChange={e => dispatch(setProjectCode(e.target.value.replace(/[^\S]/, '')))}
										onBlur={e => {
											if (e.target.value.trim() === '') {
												e.target.classList.add('input-no-valid')
											}
										}}
									/>
								</div>
							</Grid>

							<Grid item xs>
								<div style={{ display: 'flex', flexDirection: 'column' }}>
									<label htmlFor='group-number' style={{ marginBottom: 4, fontSize: 14 }}>
										Группа инвестиционного проекта
									</label>
									<CustomAutocomplete
										options={investGroups.map((item: any) => ({
											id: item.id,
											name: item.number,
											description: item.title,
										}))}
										valueProp={projectObj.groupNum}
										placeholder='Номер группы'
										onInputChange={handleInputChange}
										disabled={isArchived || isLocked}
									/>
								</div>
							</Grid>
						</Grid>
					</Grid>
					<Grid item xs={3}>
						<Box display='flex' alignItems='flex-end' style={{ gap: 12 }}>
							<Box display='flex' flexDirection='column' style={{ flexGrow: 1 }}>
								<label style={{ marginBottom: 4, color: '#555', fontSize: 14 }}>Версия</label>
								<TextField
									fullWidth
									variant='outlined'
									size='small'
									value={projectObj.version}
									placeholder='Версия'
									disabled={isArchived || isLocked}
									onChange={e => {
										dispatch(changeVersionName(e.target.value))
									}}
									InputProps={{
										classes: {
											root: 'full-width input-text-size', // если у тебя есть кастомный класс
										},
									}}
								/>
							</Box>

							<Box display='flex' alignItems='flex-end' style={{ paddingBottom: 8 }}>
								<PopupState variant='popover' popupId='demo-popup-popover'>
									{popupState => (
										<div>
											<IconButton {...bindTrigger(popupState)} size='medium' style={{ padding: 0 }}>
												<ListIcon fontSize='large' />
											</IconButton>
											<Popover
												{...bindPopover(popupState)}
												anchorOrigin={{
													vertical: 'bottom',
													horizontal: 'left',
												}}
												transformOrigin={{
													vertical: 'top',
													horizontal: 'center',
												}}
											>
												<Box display='flex' flexDirection='column'>
													<Box p={2} display='flex' style={{ gap: 6 }}>
														<Input
															inputValue={newAddedVersionName}
															placeholderValue='Добавить версию'
															disabled={isArchived || isLocked}
															handleInput={e => {
																setNewAddedVersionName(e.target.value)
															}}
															classes='full-width input-text-size'
														>
															<IconButton
																size='small'
																onClick={() => setIsOpenAddVersionDate(true)}
																disabled={isArchived || isLocked}
															>
																<InsertInvitationIcon fontSize='small' color='primary' />
															</IconButton>
														</Input>
														<Button
															size='small'
															disabled={newAddedVersionName.length < 3 || isArchived || isLocked}
															color='primary'
															variant='contained'
															onClick={() => {
																dispatch(AddNewVersion(projectObj, newAddedVersionName, typePageUrl))
																setNewAddedVersionName('')
															}}
														>
															<AddIcon fontSize='small' style={{ color: 'white' }} />
														</Button>
														<DatePicker
															open={isOpenAddVersionDate}
															onOpen={() => setIsOpenAddVersionDate(true)}
															onClose={() => setIsOpenAddVersionDate(false)}
															value={selectedDate}
															onChange={handleDateChange}
															TextFieldComponent={() => null}
														/>
													</Box>
													<List>
														{(originalObj?.versions as {
															userProjectId: number
															name: string
															is_actual: boolean
															unc_sort: string
														}[])?.map(
															(version: {
																userProjectId: number
																name: string
																is_actual: boolean
																unc_sort: string
															}) => (
																<ListItem
																	style={{ paddingLeft: 16, paddingRight: 16 }}
																	key={version.userProjectId}
																	button
																	component={Link}
																	selected={version.userProjectId == userProjectId}
																	to={`/${'user-projects'}/project/${version.userProjectId}/parameters`}
																>
																	<ListItemText primary={version.name} />
																	<Chip size='small' label={version.unc_sort} />
																</ListItem>
															)
														)}
													</List>
												</Box>
											</Popover>
										</div>
									)}
								</PopupState>
							</Box>
						</Box>
					</Grid>

					<Grid item xs={3}>
						<Box
							display='flex'
							flexDirection='column'
							justifyContent='center'
							style={{ height: '100%' }}
							paddingTop={2.5}
						>
							<CheckboxItem
								checked={Boolean(projectObj.unc_auto_add)}
								handler={handlerChangeCheckbox}
								disabled={isArchived || isLocked}
								label='авторасстановки ПИР, Б1-С1'
								name='unc_auto_add'
							/>
						</Box>
					</Grid>
				</Grid>
				<Grid container spacing={2} alignItems='flex-end'>
					<Grid item xs>
						<div style={{ display: 'flex', flexDirection: 'column' }}>
							<label style={{ marginBottom: 4, color: '#555', fontSize: 14 }}>Наименование титула</label>
							<TextareaAutosize
								placeholder='Наименование инвестиционного объекта'
								disabled={isArchived || isLocked}
								value={projectObj.name || ''}
								onChange={e => dispatch(setProjectName(e.currentTarget.value))}
								className='check-plate-textarea'
							/>
						</div>
					</Grid>
					<Grid item>
						<IconButton
							style={{ marginBottom: '8px' }}
							data-popup='set-comment'
							onClick={e => setAnchorEl!(e.currentTarget)}
						>
							<Chat />
						</IconButton>
						{anchorEl?.dataset.popup === 'set-comment' && (
							<CommentModal
								anchorEl={anchorEl}
								setAnchorEl={setAnchorEl!}
								handler={() => {
									handlerClickSave()
									setAnchorEl!(null!)
								}}
								value={projectObj.offerRationale || ''}
								onChange={(e: any) => dispatch(setProjectRationale(e.currentTarget.value))}
							/>
						)}
					</Grid>
				</Grid>
				<div
					style={{ background: '#F1F1F1', margin: '20px 0', borderRadius: '8px', padding: '10px', fontSize: '14px' }}
				>
					Реквизиты
				</div>
				<Grid container spacing={3} alignItems='flex-end'>
					<Grid item xs={6}>
						<LabelInput tooltip='Субъект РФ' title='Субъект РФ' />
						<Select
							subject={true}
							list={[...regions].sort((a, b) => a.searchName.localeCompare(b.searchName))}
							placeholder='Выберете'
							tooltip='Субъект РФ'
							multy={true}
							disabled={isArchived}
							changeHandler={val => {
								if (!isLocked) {
									const regionIds = val.map((region: IRegion) => region.id)
									dispatch(setProjectRegions(regionIds))
								}
							}}
							defaultVal={defaultRegions}
							wrapClass='is_subject'
						/>
					</Grid>
					<Grid item xs={3}>
						<LabelInput tooltip='Филиал/подразделение' title='Филиал/подразделение' />
						<Select
							subject={true}
							list={initFilial}
							placeholder='Все филиалы'
							tooltip='Филиал'
							multy={false}
							disabled={!initFilial?.length || isArchived}
							changeHandler={val => {
								if (!isLocked) dispatch(setProjectFilial(val.id))
							}}
							defaultVal={defaultFilial}
						/>
					</Grid>
					<Grid item xs={3} zeroMinWidth>
						<LabelInput
							tooltip='20.1_7 Текущая стадия реализации (этапа) инвестиционного проекта'
							title='Текущая стадия реализации (этапа) инвестиционного проекта'
						/>
						<div className='full-width stage-select input-text-size'>
							<StageSelect
								subject={true}
								list={projectPhases.map(phase => ({ id: phase.value, name: phase.fullName, title: phase.title }))}
								placeholder='Выберите стадию'
								tooltip='Стадия'
								multy={false}
								disabled={!projectPhases.length || isArchived || isLocked}
								changeHandler={val => {
									if (!isLocked) dispatch(setProjectPhase(val?.id as string))
								}}
								defaultVal={projectObj.phase ? { id: projectObj.phase, name: projectObj.phase } : null}
							/>
						</div>
					</Grid>
				</Grid>
				<Grid container spacing={3} alignItems='flex-end'>
					<Grid item xs={6}>
						<LabelInput
							tooltip='20.1_11 Наименование документа, согласно которому утверждены технологические решения'
							title='Наименование документа, согласно которому утверждены технологические решения'
						/>
						<TextField
							fullWidth
							variant='outlined'
							size='small'
							InputProps={{
								classes: {
									root: 'full-width',
								},
							}}
							value={projectObj.decreeName || ''}
							disabled={isArchived || isLocked}
							placeholder='Введите'
							onChange={e => dispatch(setProjectDecreeName(e.target.value))}
						/>
					</Grid>
					<Grid item xs={6}>
						<LabelInput
							tooltip='Реквизиты документа, согласно которому утверждены технологические решения'
							title='Реквизиты документа, согласно которому утверждены технологические решения'
						/>

						<TextField
							fullWidth
							variant='outlined'
							size='small'
							InputProps={{
								classes: {
									root: 'full-width input-text-size',
								},
							}}
							value={projectObj.decreeNumber || ''}
							disabled={isArchived || isLocked}
							placeholder='Введите'
							onChange={e => dispatch(setProjectDecreeNumber(e.target.value))}
						/>
					</Grid>
				</Grid>
				<div
					style={{ background: '#F1F1F1', margin: '20px 0', borderRadius: '8px', padding: '10px', fontSize: '14px' }}
				>
					Параметры финансирования
				</div>
				<Box p={1}>
					<Grid container spacing={2} alignItems='stretch'>
						<Grid
							item
							xs={6}
							style={{
								borderRadius: '5px',
								border: '1px solid #D7D7D7',
								padding: 0,
								display: 'flex',
								flexDirection: 'column',
							}}
						>
							<Grid
								container
								style={{
									background: '#F4F4F4',
									alignItems: 'center',
									padding: '5px',
									color: '#292A34',
								}}
							>
								<Grid item xs={2}>
									<Typography variant='subtitle2' style={{ color: '#292A34', fontSize: '11px' }}>
										Год
									</Typography>
								</Grid>
								<Grid item xs={3}>
									<Typography variant='subtitle2' style={{ color: '#292A34', fontSize: '11px' }}>
										Индекс дефляторы, %
									</Typography>
								</Grid>
								<Grid item xs={7}>
									<Typography variant='subtitle2' style={{ fontSize: '11px', color: '#292A34' }}>
										Объем финансирования инвестиций по годам с НДС, млн. ₽
									</Typography>
								</Grid>
							</Grid>

							{/* Строки таблицы */}
							{deflators.map((row: any, index: number) => (
								<Grid
									container
									key={row.year}
									alignItems='center'
									style={{
										padding: '15px 7px',
										borderBottom:
											index !== deflators.length - 1 || deflators.length === 1 ? '1px solid #E0E0E0' : 'none',
									}}
								>
									<Grid item xs={2}>
										<Typography>{row.year}</Typography>
									</Grid>
									<Grid item xs={3}>
										<Typography>{row.deflator}</Typography>
									</Grid>
									<Grid item xs={7}>
										<InputBox
											inputValue={resultMap[row.year] ?? ''}
											placeholderValue='Введите'
											disabled={isArchived || isLocked}
											changeFunc={(value: string) => {
												setResultMap(prev => ({
													...prev,
													[row.year]: value,
												}))

												const numeric = Number(value.replace(/\s/g, '').replace(',', '.'))
												const formatted = isNaN(numeric) ? 0 : Number((numeric * 1_000_000).toFixed(precision))

												const updatedYears = {
													...projectObj.years,
													[row.year]: {
														...projectObj.years[row.year],
														offer: formatted,
													},
												}

												dispatch(setYears(updatedYears))
											}}
											InputIntShow={true}
											classes='full-width'
											precision={precision}
											hideCurrencyLabel={true}
										/>
									</Grid>
								</Grid>
							))}
						</Grid>

						{/* Правая часть - Информация */}
						<Grid item xs={6}>
							<div style={{ marginBottom: 16 }}>
								<Typography variant='subtitle2' gutterBottom>
									Период реализации
								</Typography>

								<div
									style={{
										display: 'flex',
										gap: '20px',
										marginBottom: '10px',
									}}
									className='year_interval'
								>
									<Grid item xs={6}>
										<CalendarOnce
											placeholder='Год начала'
											changeHandler={value => handleYearsChange(value[0], 'start')}
											defaultVal={[2018, 2025]}
											value={projectYears}
											wrapClass='no_padding year_interval'
											tooltip='Год начала'
											format='yyyy'
											views={['year']}
											dateCorrectLength={4}
											isDisabled={isArchived || isLocked}
											min={2000}
											max={projectYears[1] || 2050}
											type='start'
										/>
									</Grid>

									<Grid item xs={6}>
										<CalendarOnce
											placeholder='Год окончания'
											changeHandler={value => handleYearsChange(value[1], 'end')}
											defaultVal={[2018, 2025]}
											value={projectYears}
											wrapClass='no_padding year_interval'
											tooltip='Год окончания'
											format='yyyy'
											views={['year']}
											dateCorrectLength={4}
											isDisabled={isArchived || isLocked}
											min={projectYears[0] || 2000}
											max={2050}
											type='end'
										/>
									</Grid>
								</div>

								<Typography variant='subtitle2'>Факт. объем финансирования на 01.01.2023 (с НДС), млн. ₽</Typography>
								<InputBox
									inputValue={projectObj.actualFunding ? projectObj.actualFunding / 10 ** 6 : '0'}
									placeholderValue='Введите'
									disabled={isArchived || isLocked}
									changeFunc={(value: string) => {
										dispatch(setProjectActual(+value * 10 ** 6))
									}}
									InputIntShow={true}
									classes='full-width input-text-size'
									precision={precision}
									hideCurrencyLabel={true}
								/>

								<Typography variant='subtitle2' style={{ marginTop: '10px' }}>
									Оценка полной стоимости в прогнозных ценах соотв. лет (с НДС), млн. ₽
								</Typography>
								<InputBox
									inputValue={projectObj.valuationOfferForecast ? projectObj.valuationOfferForecast / 10 ** 6 : '0'}
									placeholderValue='Введите'
									disabled={isArchived || isLocked}
									changeFunc={(value: string) => {
										dispatch(setProjectValuation(+value * 10 ** 6))
									}}
									InputIntShow={true}
									classes='full-width'
									precision={precision}
									hideCurrencyLabel={true}
								/>

								<Typography variant='subtitle2' style={{ marginTop: '10px' }}>
									Сумма ненормируемых затрат (с НДС), млн. ₽
								</Typography>
								<div
									style={{
										display: 'flex',
										alignItems: 'flex-end',
										gap: 8,
									}}
								>
									<InputBox
										inputValue={projectObj.additionalFundingOffer ? projectObj.additionalFundingOffer / 10 ** 6 : '0'}
										placeholderValue=''
										disabled={true}
										changeFunc={(value: string) => {
											dispatch(setProjectAdditional(+value * 10 ** 6))
										}}
										InputIntShow={true}
										classes='full-width input-text-size'
										precision={precision}
										hideCurrencyLabel={true}
									/>
									<Button
										data-popup='open-table-form20'
										aria-haspopup='true'
										onClick={e => {
											if (projectSaved) {
												dispatch(getT7Data(userProjectId, 2))
												setAnchorEl!(e.currentTarget)
												setAccessory!('open-table-form20')
												typePageUrl === 'user-archive'
													? dispatch(setT7EditModeArchive(!t7EditMode))
													: dispatch(setT7EditMode(!t7EditMode))
											} else {
												dispatch(
													showNotify({
														type: 'warning',
														message: `Сначала необходимо сохранить проект`,
													})
												)
											}
										}}
										variant='outlined'
										size='small'
										style={{
											whiteSpace: 'nowrap',
											height: 30,
											borderColor: '#00AEEF',
											color: '#00AEEF',
											padding: '16px 16px',
											textTransform: 'none',
										}}
									>
										Редактировать
									</Button>
								</div>
							</div>
						</Grid>
					</Grid>

					{/* Нижняя строка: Индексы и Приказ */}
					<Grid container spacing={2} style={{ marginTop: 8 }}>
						<Grid item xs={6}>
							<Box display='flex' justifyContent='flex-end' pr={1}>
								<Typography
									component='a'
									href='https://www.economy.gov.ru/material/directions/makroec/prognozy_socialno_ekonomicheskogo_razvitiya/pismo_minekonomrazvitiya_rossii_ot_2_oktyabrya_2024g_35132_pkd03i.html'
									target='_blank'
									rel='noopener noreferrer'
									variant='caption'
									color='primary'
									style={{ textDecoration: 'none', cursor: 'pointer' }}
								>
									ⓘ Индексы
								</Typography>
							</Box>
						</Grid>
						<Grid item xs={6}>
							<Box display='flex' justifyContent='flex-end'>
								<Typography variant='caption' color='primary'>
									<PrikazLinks uncSort={Number(projectObj.unc_sort)} url={typePageUrl} />
								</Typography>
							</Box>
						</Grid>
					</Grid>
				</Box>
				<div
					style={{ background: '#F1F1F1', margin: '20px 0', borderRadius: '8px', padding: '10px', fontSize: '14px' }}
				>
					Результаты расчетов
				</div>
				<Box
					style={{
						borderRadius: 5,
						overflow: 'hidden',
						marginTop: 16,
					}}
				>
					{/* Заголовки таблицы */}
					<Grid
						container
						alignItems='stretch'
						style={{
							background: '#F8F8F8',
							padding: '0 8px',
						}}
					>
						<Grid item xs={6} style={{ padding: '5px', borderRight: '2px solid white' }}>
							<Typography variant='caption' display='block' style={{ borderBottom: '1px solid #E0E0E0' }}>
								Итого ОФП по УНЦ <br />в текущих ценах, млн. ₽
							</Typography>
							<Box display='flex'>
								<Box style={{ width: '50%' }}>
									<Typography variant='caption'>Без НДС</Typography>
								</Box>
								<Box style={{ width: '50%' }}>
									<Typography variant='caption'>С НДС</Typography>
								</Box>
							</Box>
						</Grid>

						<Grid item xs={3} style={{ padding: '5px', borderRight: '2px solid white' }}>
							<Typography variant='caption'>
								Непревышение РПС <br />
								над УНЦ (с НДС), млн. ₽
							</Typography>
						</Grid>
						<Grid item xs={3} style={{ padding: '5px' }}>
							<Typography variant='caption' display='block'>
								Обьем финансовых потребностей по УНЦ <br />в прогнозных ценах (с НДС), млн. ₽
							</Typography>
						</Grid>
					</Grid>

					{/* Значения */}
					<Grid container alignItems='center' style={{ padding: '8px', borderBottom: '1px solid #E0E0E0' }}>
						{/* Итого ОФП по УНЦ */}
						<Grid item xs={6} style={{ padding: '5px' }}>
							<Box display='flex' justifyContent='space-between' alignItems='center'>
								<Box width='50%'>
									<Typography>
										{projectObj.sumUncCost || projectObj.sumUncCost === 0 ? (
											<>
												<div>{`${prettyCost(projectObj.sumUncCost / 10 ** 6, precision)}`}</div>
											</>
										) : (
											<span className='no_cost'>-</span>
										)}
									</Typography>
								</Box>
								<Box width='50%'>
									<Typography>
										{projectObj.sumUncCostWithNds || projectObj.sumUncCostWithNds === 0 ? (
											<>
												<div>{`${prettyCost(projectObj.sumUncCostWithNds / 10 ** 6, precision)}`}</div>
											</>
										) : (
											<span className='no_cost'>-</span>
										)}
									</Typography>
								</Box>
							</Box>
						</Grid>
						{/* Неревышение РПС */}
						{/* было projectObj.rps_unc_exceeding */}
						<Grid item xs={3} style={{ padding: '5px' }}>
							<Typography
								style={
									totalInvestmentUncOffer > 0 &&
									valuationOfferForecast > 0 &&
									totalInvestmentUncOffer - valuationOfferForecast > 0
										? {}
										: { color: '#C04100' }
								}
							>
								{totalInvestmentUncOffer > 0 && valuationOfferForecast > 0 ? (
									<div>{prettyCost((totalInvestmentUncOffer - valuationOfferForecast) / 10 ** 6)}</div>
								) : (
									<span className='no_cost'>-</span>
								)}
							</Typography>
						</Grid>
						{/*  Объем финансовых потребностей*/}
						<Grid item xs={3} style={{ padding: '5px' }}>
							<Typography>
								{projectObj.totalInvestmentUncOffer || projectObj.totalInvestmentUncOffer === 0 ? (
									<>
										<div style={red}>
											{`${prettyCost(
												Number(intFormat(projectObj.totalInvestmentUncOffer / 10 ** 6, true, precision + 1)).toFixed(
													precision
												),
												precision
											)}`}
										</div>
									</>
								) : (
									<span className='no_cost'>-</span>
								)}
							</Typography>
						</Grid>
					</Grid>
				</Box>
				{!isArchived && !isLocked ? (
					<div className='wrapper-controls'>
						<div>
							<SecondaryBtn onClick={openWindow} data-popup='check-project'>
								Проверить
							</SecondaryBtn>
						</div>
						<div>
							{projectObj?.id ? (
								<SecondaryBtn disabled={!isUpdated} onClick={cancelProjectUpdates} data-popup='check-project'>
									Отмена
								</SecondaryBtn>
							) : null}
						</div>
						<div className='checkproject_wrapper'>
							<PrimaryBtn disabled={projectObj?.id ? !isUpdated : false} onClick={handlerClickSave}>
								{saveButtonTitle()}
							</PrimaryBtn>
							{anchorEl?.dataset.popup === 'check-project' && (
								<CheckProjectWindow
									setAnchorEl={setAnchorEl!}
									anchorEl={anchorEl}
									sectionIds={sectionIds}
									sectionIdsArr={sectionIdsArr}
									setAccessory={setAccessory}
									accessory={accessory}
									accessoryRef={accessoryRef}
									handler={() => {
										setAccessory!('error-list')
										if (accessoryRef) accessoryRef.current = accessory
										dispatch(getCheckedErrors(projectObj.id, selectedSectionIds))
									}}
									handlerAutoAddUnc={() => {
										dispatch(autoAddUnc(projectObj.id, selectedSectionIds))
									}}
								/>
							)}
						</div>
					</div>
				) : null}
			</div>
			{failure && <FailurePage />}
			{anchorEl?.dataset.popup === 'select-an-action' &&
				(!projectSaved ? (
					<div className='modal_over'>Необходимо сохранить проект</div>
				) : (
					<SelectAction
						anchorEl={anchorEl!}
						setAnchorEl={setAnchorEl!}
						getTplUnnormalizedСosts={() =>
							!isArchived
								? dispatch(getTplUnnormalizedСosts(projectObj.id!))
								: dispatch(getTplUnnormalizedСostsArchive(projectObj.id!))
						}
						uploaderUnnormalizedСosts={e =>
							!isArchived
								? dispatch(uploaderUnnormalizedСosts(e.target.files, projectObj.id!))
								: dispatch(uploaderUnnormalizedСostsArchive(e.target.files, projectObj.id!))
						}
						getUnnormalizedСosts={() =>
							!isArchived
								? dispatch(getUnnormalizedСosts(projectObj.id!))
								: dispatch(getUnnormalizedСostsArchive(projectObj.id!))
						}
						deleteUnnormalizedСosts={() =>
							!isArchived
								? dispatch(deleteUnnormalizedСosts(projectObj.id!))
								: dispatch(deleteUnnormalizedСostsArchive(projectObj.id!))
						}
						t7Id={projectObj.t7Id!}
					/>
				))}
			{anchorEl?.dataset.popup === 'open-table' && (
				<UnNormalizedCosts
					isArchived={isArchived}
					isLocked={isLocked}
					anchorEl={anchorEl!}
					setAnchorEl={setAnchorEl!}
					t7EditMode={t7EditMode}
				/>
			)}
			{anchorEl?.dataset.popup === 'open-table-form20' && (
				<UnNormalizedForm20Costs
					isArchived={isArchived}
					isLocked={isLocked}
					anchorEl={anchorEl!}
					setAnchorEl={setAnchorEl!}
					t7EditMode={t7EditMode}
					isNewVersion={isNewVersion}
				/>
			)}
		</div>
	)
}

export { CheckPlate }
